// extracted by mini-css-extract-plugin
module.exports = {"deliveryDate":"EstimatedDelivery_deliveryDate__ag2l2","deliveryText":"EstimatedDelivery_deliveryText__OUjNi"};